type Handler<T> = (payload: T) => void

/** Простой типизированный bus без зависимостей от React/Three */
export class EventBus<Events extends object> {
  private listeners = new Map<keyof Events, Set<Handler<unknown>>>()

  on<K extends keyof Events>(event: K, handler: Handler<Events[K]>): () => void {
    let set = this.listeners.get(event)
    if (!set) {
      set = new Set()
      this.listeners.set(event, set)
    }
    set.add(handler as Handler<unknown>)
    return () => set!.delete(handler as Handler<unknown>)
  }

  emit<K extends keyof Events>(event: K, payload: Events[K]): void {
    const set = this.listeners.get(event)
    if (!set) return
    for (const handler of set) {
      ;(handler as Handler<Events[K]>)(payload)
    }
  }

  clear(): void {
    this.listeners.clear()
  }
}
